import { Component} from '@angular/core';

@Component({
	selector: 'app-user-externo',
	templateUrl: './user-externo.component.html',
	styleUrls: ['./user-externo.component.css']
})
export class UserExternoComponent {

	constructor() { }


}